import { translateFormatter } from '@/domains/core/localization/translate';
export const t = translateFormatter<{
  votes: number;
}>("{votes, plural, =0 {Be the first to find this useful} =1 {1 person found this useful} other {# people found this useful}}", undefined, undefined, "en");